var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "see-idfa" }, [
    _c("div", { staticClass: "idfa-body" }, [
      _c("i", {
        staticClass: "el-icon-warning",
        staticStyle: {
          "font-size": "24px",
          "margin-right": "8px",
          color: "#faad14"
        }
      }),
      _c("div", { staticClass: "idfa-cont" }, [_vm._v(_vm._s(_vm.idfa))])
    ]),
    _c("div", { staticClass: "dialog-footer" }, [
      _c("input", {
        staticClass: "btn btn-red",
        attrs: { type: "button", value: "确认" },
        on: {
          click: function($event) {
            return _vm.cancel()
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }